import React from "react";
import Skeleton from "react-loading-skeleton";

const Loading = () => {
  return (
    <main className="loading-content">
      <Skeleton count={50} />
    </main>
  );
};

export default Loading;
